const nikeSubBrands = [
  { name: 'Air Force 1', slug: 'air-force-1', type: 'link' },
  { name: 'Air Max 1', slug: 'air-max-1', type: 'link' },
  { name: 'Air Max 90', slug: 'air-max-90', type: 'link' },
  { name: 'Air Max 95', slug: 'air-max-95', type: 'link' },
  { name: 'Dunk', slug: 'dunk', type: 'link' },
  {
    name: 'TN Air Max Plus',
    slug: 'tn-air-max-plus',
    type: 'link'
  },
  { name: 'P-6000', slug: 'p-6000', type: 'link' }
];

const jordanBrands = [
  { name: 'Air Jordan 1', slug: 'air-jordan-1', type: 'link' },
  { name: 'Air Jordan 3', slug: 'air-jordan-3', type: 'link' },
  { name: 'Air Jordan 4', slug: 'air-jordan-4', type: 'link' },
  {
    name: 'Air Jordan Spizike',
    slug: 'air-jordan-spizike',
    type: 'link'
  }
];

const adidasSubBrands = [
  { name: 'Campus', slug: 'campus', type: 'link' },
  { name: 'Gazelle', slug: 'gazelle', type: 'link' },
  { name: 'Samba', slug: 'samba', type: 'link' },
  { name: 'SL72', slug: 'sl72', type: 'link' },
  { name: 'Spezial', slug: 'spezial', type: 'link' },
  { name: 'Stan Smith', slug: 'stan-smith', type: 'link' },
  { name: 'Superstar', slug: 'superstar', type: 'link' }
];

const newBalanceSubBrands = [
  { name: '327', slug: '327', type: 'link' },
  { name: '530', slug: '530', type: 'link' },
  { name: '550', slug: '550', type: 'link' },
  { name: '990', slug: '990', type: 'link' },
  { name: '9060', slug: '9060', type: 'link' },
  { name: '1906R', slug: '1906r', type: 'link' }
];

const uggSubBrands = [
  { name: 'Lowmel', slug: 'lowmel', type: 'link' },
  { name: 'Tasman', slug: 'tasman', type: 'link' },
  { name: 'Tazz', slug: 'tazz', type: 'link' },
  {
    name: 'Classic Boots',
    slug: 'ultra-mini-boots',
    type: 'link'
  }
];

export const mobile = [
  {
    children: [
      {
        link: '/release-dates/',
        name: 'Was ist angesagt',
        type: 'filter'
      },
      {
        link: '/release-dates/?sort=LATEST_RELEASES',
        name: 'Neue Releases',
        type: 'filter'
      },
      {
        link: '/release-dates/?sort=UPCOMING_RELEASES',
        name: 'Launches',
        type: 'filter'
      },
      {
        children: [
          { link: '/release-dates/nike/', name: 'Nike entdecken' },
          ...nikeSubBrands
        ],
        icon: 'nike',
        name: 'Nike',
        path: '/release-dates/nike/',
        type: 'brand'
      },
      {
        children: [
          { link: '/release-dates/nike/jordan/', name: 'Jordan entdecken' },
          ...jordanBrands
        ],
        icon: 'jordan',
        name: 'Jordan',
        path: '/release-dates/nike/',
        type: 'brand'
      },
      {
        children: [
          { link: '/release-dates/adidas/', name: 'adidas entdecken' },
          ...adidasSubBrands
        ],
        icon: 'adidas',
        name: 'adidas',
        path: '/release-dates/adidas/',
        type: 'brand'
      },
      {
        children: [
          {
            link: '/release-dates/new-balance/',
            name: 'New Balance entdecken'
          },
          ...newBalanceSubBrands
        ],
        icon: 'newBalance',
        name: 'New Balance',
        path: '/release-dates/new-balance/',
        type: 'brand'
      },
      {
        children: uggSubBrands,
        icon: 'ugg',
        name: 'UGG',
        path: '/release-dates/ugg/',
        type: 'brand'
      }
    ],
    name: 'Schuhe',
    path: '/release-dates/',
    slug: 'release-dates'
  },
  {
    name: 'Launches',
    path: '/release-dates/?sort=UPCOMING_RELEASES',
    slug: 'release-dates-upcoming'
  },
  {
    name: 'Neue Releases',
    path: '/release-dates/?sort=LATEST_RELEASES',
    slug: 'release-dates-latest'
  },
  {
    name: 'Sale',
    path: '/release-dates/?sort=SALE',
    slug: 'release-dates-sale'
  }
];

export const desktop = [
  {
    content: {
      footwear: {
        featuredBrands: {
          children: [
            {
              children: nikeSubBrands,
              icon: 'nike',
              name: 'Nike',
              path: '/release-dates/nike/',
              slug: 'nike',
              viewAll: {
                label: 'Nike entdecken',
                link: ''
              }
            },
            {
              children: jordanBrands,
              icon: 'jordan',
              name: 'Jordan',
              path: '/release-dates/nike/',
              slug: 'jordan',
              viewAll: {
                label: 'Jordan entdecken',
                link: 'jordan/'
              }
            },
            {
              children: adidasSubBrands,
              icon: 'adidas',
              name: 'adidas',
              path: '/release-dates/adidas/',
              slug: 'adidas',
              viewAll: {
                label: 'adidas entdecken',
                link: ''
              }
            },
            {
              children: newBalanceSubBrands,
              icon: 'newBalance',
              name: 'New Balance',
              path: '/release-dates/new-balance/',
              slug: 'new-balance',
              viewAll: {
                label: 'New Balance entdecken',
                link: ''
              }
            },
            {
              children: uggSubBrands,
              icon: 'ugg',
              name: 'UGG',
              path: '/release-dates/ugg/',
              slug: 'ugg'
            }
          ]
        },
        filters: [],
        icon: 'footwear',
        title: 'Footwear'
      },
      render: true
    },
    link: '/release-dates/',
    name: 'Schuhe',
    slug: 'release-dates'
  },
  {
    link: '/release-dates/?sort=UPCOMING_RELEASES',
    name: 'Launches',
    slug: 'release-dates-upcoming'
  },
  {
    link: '/release-dates/?sort=LATEST_RELEASES',
    name: 'Neue Releases',
    slug: 'release-dates-latest'
  },
  {
    link: '/release-dates/?sort=SALE',
    name: 'Sale',
    slug: 'release-dates-sale'
  }
];

export default {
  desktop,
  mobile
};
